import React from "react";
import { useTranslation } from "react-i18next";
import "./AdressCard.css";
import { useDispatch } from "react-redux";
import Button from "../../../Common/FormElements/Button/Button";
import { openCenteredModal } from "../../../../REDUX/actions/centeredModal";
import FormAdress from "./FormAdress";

const NewAdressCard = ({
  address,
  type = "addresseDeLivraison",
  prospectId,
  callBack = () => {},
}) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  return (
    <div
      className={`adressCardContainer br10 p-3 cursor-pointer border ${"bg-dimGrey"}`}
    >
      <div>
        {/* <p>
          <i class="bi bi-trash3 text-lameRed pointer"></i>
        </p> */}
        <p className="f16 text-brightGrey mb-1">{address.attributes?.name} </p>
        <p className="f16 text-brightGrey mb-1">
          {address.attributes?.street}{" "}
        </p>
        <p className="f16 text-brightGrey mb-1">
          {address.attributes?.city?.data?.attributes?.name}
        </p>
        <p className="f16 text-brightGrey mb-2">{address.attributes?.zip}</p>
        <p className="f16 text-brightGrey mb-1">
          {address.attributes?.country?.data?.attributes?.name}
        </p>
      </div>
      <div className="d-flex gap-2">
        <Button
          className="mt-2 w50"
          onClick={() =>
            dispatch(
              openCenteredModal(
                <FormAdress
                  prospectId={prospectId}
                  type={type}
                  address={address}
                  callBack={callBack}
                />
              )
            )
          }
        >
          {t("Edit")}
        </Button>
      </div>
    </div>
  );
};

export default NewAdressCard;
